import { cn } from '@/lib/cn';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
  count?: number;
}

interface TabsProps {
  items: TabItem[];
  active: string;
  onChange: (id: string) => void;
  className?: string;
}

export default function Tabs({ items, active, onChange, className }: TabsProps) {
  return (
    <div
      role="tablist"
      className={cn(
        'inline-flex max-w-full flex-nowrap items-center gap-1 overflow-x-auto lb-no-scrollbar rounded-full border border-background-200 bg-background-100 px-1 py-1',
        className,
      )}
    >
      {items.map((item) => {
        const isActive = item.id === active;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(item.id)}
            className={cn(
              'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 h-9 text-sm font-medium transition-all duration-200 ease-smooth cursor-pointer',
              isActive
                ? 'bg-background-50 text-primary-700 border border-background-200 shadow-xs'
                : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-50/60',
            )}
          >
            {item.icon ? <i className={cn(item.icon, 'text-base leading-none')} aria-hidden="true" /> : null}
            {item.label}
            {typeof item.count === 'number' ? (
              <span
                className={cn(
                  'inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-xs',
                  isActive ? 'bg-primary-100 text-primary-800' : 'bg-background-200 text-foreground-600',
                )}
              >
                {item.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}